import {CLEAR_AJAX_ERROR} from '../../constants';

export type ClearAjaxErrorAction = {
    /**
     * The action type
     */
    type : typeof CLEAR_AJAX_ERROR;

    /**
     * The uid of the component the requests belongs to
     */
    componentUid : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} componentUid         The uid of the component the requests belongs to
 *
 * @return {ClearAjaxErrorAction}
 */
const clearAjaxError = ( componentUid : string = 'global' ) : ClearAjaxErrorAction => {
    return {
        type: CLEAR_AJAX_ERROR,
        componentUid
    };
}
export type ClearAjaxError = typeof clearAjaxError;

export default clearAjaxError;
